import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '@careandkey/shared';
import { Layout, Topbar } from '../components/Layout';

// Help / Manual module. Content is i18n data (module → Q/A), fully translatable;
// client-side search over question + answer. Topics are extensible.
const TOPICS = [
  { key: 't1', items: ['q1', 'q2'] },
  { key: 't2', items: ['q1', 'q2'] },
  { key: 't3', items: ['q1', 'q2'] },
  { key: 't4', items: ['q1', 'q2'] },
];

export function Help() {
  const { t } = useTranslation();
  const [q, setQ] = useState('');

  const sections = useMemo(() => {
    const needle = q.trim().toLowerCase();
    return TOPICS.map((topic) => ({
      title: t(`help.${topic.key}.title`),
      items: topic.items
        .map((it) => ({ question: t(`help.${topic.key}.${it}.q`), answer: t(`help.${topic.key}.${it}.a`) }))
        .filter((it) => !needle || (it.question + it.answer).toLowerCase().includes(needle)),
    })).filter((s) => s.items.length > 0);
  }, [q, t]);

  return (
    <Layout header={<Topbar />}>
      <div className="mx-auto flex w-full max-w-[860px] flex-col gap-5 px-7 py-6">
        <h1 className="text-[30px] font-semibold tracking-[-0.02em]">{t('nav.help')}</h1>
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder={t('help.search')}
          className="h-10 w-full rounded-md border border-border bg-card px-3 text-fg outline-none focus-visible:shadow-focus"
        />
        {sections.map((s) => (
          <section key={s.title} className="flex flex-col gap-2">
            <h2 className="eyebrow">{s.title}</h2>
            {s.items.map((it) => (
              <Card key={it.question} className="p-4">
                <div className="font-medium">{it.question}</div>
                <p className="mt-1 text-sm text-muted">{it.answer}</p>
              </Card>
            ))}
          </section>
        ))}
        {sections.length === 0 && <div className="text-sm text-muted">{t('common.noData')}</div>}
      </div>
    </Layout>
  );
}
